export const SHPW_DATA = 'home_data'
export const PRE_ORDER_DATA = 'PRE_ORDER_DATA'